import { BaseContainerModel } from "../base-container.model";
import {
  bl_fi_generic_doc_ext_RowClass,
  bl_fi_generic_doc_hdr_RowClass,
  bl_fi_generic_doc_hdr_RowInterface,
  bl_fi_generic_doc_line_open_queue_RowClass,
  bl_fi_generic_doc_line_RowClass,
  bl_fi_generic_doc_link_RowClass,
} from "../../dbschema";

export class GenericDocHdrLineOpenQueueImportContainerModel extends BaseContainerModel {
  bl_fi_generic_doc_hdr: bl_fi_generic_doc_hdr_RowInterface =
    new bl_fi_generic_doc_hdr_RowClass();
  bl_fi_generic_doc_lines: bl_fi_generic_doc_line_RowClass[] = [];
  bl_fi_generic_doc_line_open_queues: bl_fi_generic_doc_line_open_queue_RowClass[] = [];
  bl_fi_generic_doc_exts: bl_fi_generic_doc_ext_RowClass[] = [];
  bl_fi_generic_doc_links?: bl_fi_generic_doc_link_RowClass[] = [];
}
